import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { PersonAddStoreCreditPage } from 'src/app/modals/person-add-store-credit/person-add-store-credit.page';

const routes: Routes = [
  {
    path: '',
    component: PersonAddStoreCreditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PersonAddStoreCreditPage]
})
export class PersonAddStoreCreditPageModule {}
